import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { parseSequenceId } from '@/lib/sequenceUtils';

interface SharedSequenceConflictOverlayProps {
  isOpen: boolean;
  onPlayShared: () => void;
  onContinueExisting: () => void;
  sequenceId: string;
}

export const SharedSequenceConflictOverlay: React.FC<SharedSequenceConflictOverlayProps> = ({
  isOpen,
  onPlayShared,
  onContinueExisting,
  sequenceId
}) => {
  const sharedDate = parseSequenceId(sequenceId);
  
  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="w-[85%] max-w-none bg-gray-900 border-purple-600 border-2 text-white rounded-xl">
        <DialogHeader>
          <DialogTitle className="text-purple-400">Practice Game in Progress</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <p className="text-sm text-gray-300">
            You have a practice game in progress, but you've clicked a shared game link.
          </p>
          
          <p className="text-sm text-gray-300 text-center">
            What would you like to do?
          </p>
          
          <div className="flex flex-col gap-3">
            <Button 
              onClick={onPlayShared} 
              className="bg-purple-600 hover:bg-purple-700 text-white w-full [border:none!important]"
            >
              Play Shared Game
            </Button>
            <Button 
              onClick={onContinueExisting} 
              className="bg-gray-700 hover:bg-gray-600 text-white w-full border-0"
            >
              Continue My Game
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};